import React from "react";
import "./WelcomeSection.css";
import { Link } from "react-router-dom";

import FloatingLines from './FloatingLines';
import HeroOrbit from './HeroOrbit';

const WelcomeSection = () => {
  return (
    <section className="welcome">
      <div className="welcome-background">
        <FloatingLines
           enabledWaves={['top', 'middle', 'bottom']}
           lineCount={[7, 7, 7]}
           lineDistance={[4, 5, 6]}
           topWavePosition={{ x: 10.0, y: 0.5, rotate: -0.4 }}
           middleWavePosition={{ x: 5.0,  y: 0.0, rotate: 0.2 }}
           bottomWavePosition={{ x: 2.0, y: -0.7, rotate: -1 }}
           interactive={true}
           parallax={true}
           mixBlendMode="screen"
        />
      </div>

      <div className="welcome-content structured-layout">
        {/* Columna izquierda */}
        <div className="left-column">
          <a href="/" className="welcome-logo">
            <img src="/img/logotipo-02.png" alt="Logo SparklingTech" />
          </a>

          <h1 className="welcome-title">
            Tecnología y ciencia para transformar la calidad de vida
          </h1>

          <p className="subtitle-text">
           Desarrollamos soluciones basadas en neurociencia, inteligencia artificial y videojuegos desde nuestro laboratorio de I + D + i
          </p>

          <Link
            to="/movespark"
            className="lit-up-button"
            data-aos="zoom-in"
            data-aos-delay="600"
            data-aos-duration="800"
            data-aos-easing="ease-in-out"
            data-aos-once="true"
          >
            <div className="lit-up-border" />
            <div className="lit-up-content">
              Nuestro laboratorio
            </div>
          </Link>

        </div>

        {/* Columna derecha: proyectos orbitando alrededor de una estrella */}
        <div className="right-column">
          <HeroOrbit />
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
